var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWikiIcoTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "25px",
    viewBox: "0 0 32 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9E32CC13-71A1-43D9-BC2C-27325CEDFA8A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "15-wiki-sub-page_light",
    transform: "translate(-801.000000, -355.000000)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#191919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(802.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0906976744,0.302325581 L0.0906976744,9.88604651 L11.7906977,21.5860465 L21.3744186,12.0023256 L9.6744186,0.302325581 L0.0906976744,0.302325581 Z M11.7906977,20.7093023 L0.695348837,9.64418605 L0.695348837,0.906976744 L9.43255814,0.906976744 L20.4976744,12.0023256 L11.7906977,20.7093023 Z",
    id: "Shape",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89767442,5.10930233 C4.25099904,5.75962218 4.2529681,6.8107433 4.9020754,7.45863577 C5.55118271,8.10652825 6.60230567,8.10652825 7.25141297,7.45863577 C7.90052027,6.8107433 7.90248933,5.75962218 7.25581395,5.10930233 C6.94371588,4.79544536 6.51936299,4.61897373 6.07674419,4.61897373 C5.63412538,4.61897373 5.20977249,4.79544536 4.89767442,5.10930233 Z M6.83255814,7.04418605 C6.5316252,7.35119905 6.07485359,7.44562353 5.67685623,7.2830944 C5.27885887,7.12056526 5.01875583,6.73339257 5.01875583,6.30348837 C5.01875583,5.87358417 5.27885887,5.48641148 5.67685623,5.32388235 C6.07485359,5.16135321 6.5316252,5.25577769 6.83255814,5.5627907 C7.20811739,5.97828409 7.19486368,6.61446213 6.80232558,7.01395349 L6.83255814,7.04418605 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 2,
    points: "28.9093023 12.0023256 17.0883721 0.181395349 16.6651163 0.604651163 28.0325581 12.0023256 18.9023256 21.1627907 19.3255814 21.5860465"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiIcoTags);
export default __webpack_public_path__ + "static/media/wiki-ico-tags.98b371a6cdbd1154fb963256e9a32618.svg";
export { ForwardRef as ReactComponent };